module.exports = __webpack_public_path__ + "fc0a9f79b4f3cd259056729022ac4df2.svg";